module.exports = __webpack_public_path__ + "img/gfjg-bg0510-21.cd6eb1bb.png";